// Client-side mirror of server/api-util/processingFee.js, for price
// estimates shown before checkout. The server computes the amount actually
// charged; keep the two in sync.
//
// When the coach's price (before fees) is under $30, the customer also
// covers Stripe's card processing fee (2.9% + 30¢, grossed up so it covers
// Stripe's cut of the whole charge), shown as its own line.

export const PROCESSING_FEE_THRESHOLD_CENTS = 3000;
const STRIPE_PERCENT = 2.9;
const STRIPE_FIXED_CENTS = 30;

export const calculateProcessingFeeCents = ({
  baseAmountCents,
  otherFeesCents = 0,
  thresholdCents = PROCESSING_FEE_THRESHOLD_CENTS,
}) => {
  const base = Math.round(Number(baseAmountCents));
  const other = Math.max(0, Math.round(Number(otherFeesCents) || 0));
  if (!Number.isFinite(base) || base <= 0 || base >= thresholdCents) return 0;
  const subtotal = base + other;
  const grossed = Math.ceil((subtotal + STRIPE_FIXED_CENTS) / (1 - STRIPE_PERCENT / 100));
  return Math.max(0, grossed - subtotal);
};

// Keep in sync with server/api-util/processingFee.js.
export const PROCESSING_FEE_LABEL = 'Stripe processing fee (2.9% + 30¢, third party)';
export const platformFeeLabel = percent => {
  const n = Number(percent);
  return Number.isFinite(n) && n > 0 ? `Taxes & platform fee (${n}%)` : 'Taxes & platform fee';
};
